function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.54 9.45627C17.48 8.51674 18 7.25737 18 5.91804V2H6V5.92804C6 7.26737 6.52 8.51674 7.46 9.46627L9.29 11.2954C9.68 11.6852 9.68 12.3148 9.29 12.7046L7.46 14.5337C6.52 15.4833 6 16.7326 6 18.072V22H18V18.072C18 16.7426 17.48 15.4833 16.54 14.5337L14.71 12.7046C14.32 12.3148 14.32 11.6852 14.71 11.2954L16.54 9.46627V9.45627ZM13.3 14.1139L15.13 15.943C15.7 16.5127 16.01 17.2624 16.01 18.062V19.991H15.99C15.99 19.991 15.93 19.911 15.89 19.8811L12.65 17.1824C12.28 16.8726 11.74 16.8726 11.37 17.1824L8.13 19.8811C8.13 19.8811 8.06 19.961 8.03 19.991H8.01V18.062C8.01 17.2624 8.32 16.5127 8.89 15.943L10.72 14.1139C11.89 12.9445 11.89 11.0455 10.72 9.87606L8.89 8.04698C8.32 7.47726 8.01 6.72764 8.01 5.92804V3.999H16.01V5.92804C16.01 6.72764 15.7 7.48726 15.13 8.04698L13.3 9.87606C12.13 11.0455 12.13 12.9445 13.3 14.1139Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Hourglass.js.map